import { Space } from "antd";
import React from "react";
import { Logo } from "../Logo/Logo";

const SideNav = (props) => {
  const { mcontact, rightmenu } = props;
  return (
    <Space
      style={{ justifyContent: "space-between" }}
      size="large"
      direction="vertical"
    >
      {rightmenu && (
        <ul>
          {rightmenu.map((item) => (
            <li>
              <a href={item.url}>{item.title}</a>
            </li>
          ))}
        </ul>
      )}

      <Space size="large" direction="vertical">
        <Logo />
        <div className="megamenu__contact">
          <div dangerouslySetInnerHTML={{ __html: mcontact }} />
        </div>
      </Space>
    </Space>
  );
};

export default SideNav;
